import styled from 'styled-components';

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.inline ? 'row' : 'column')};
  gap: ${(props) => (props.inline ? '24px' : '12px')};
  flex-wrap: wrap;
`;

export const RadioLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E2E8F0' : '#334155')};
  margin-bottom: 12px;
  display: block;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
  background: ${(props) =>
    props.selected
      ? props.theme.name === 'dark'
        ? 'rgba(250, 70, 22, 0.1)'
        : 'rgba(250, 70, 22, 0.05)'
      : 'transparent'};
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme?.colors?.primary || '#FA4616'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};

  &:hover:not([disabled]) {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.02)'};
    border-color: ${(props) =>
      props.selected
        ? props.theme?.colors?.primary || '#FA4616'
        : 'rgba(250, 70, 22, 0.4)'};
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const RadioCircle = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid
    ${(props) =>
      props.checked
        ? props.theme?.colors?.primary || '#FA4616'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.3)'
        : '#d1d5db'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${(props) =>
      props.checked
        ? props.theme?.colors?.primary || '#FA4616'
        : 'transparent'};
    transition: all 0.15s ease;
  }
`;

export const RadioText = styled.span`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#E2E8F0' : '#334155')};
`;

export const HelperText = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: ${(props) => (props.error ? '#ef4444' : '#64748B')};
`;
